import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { CounterComponent } from '../counter/counter.component';
import { SentenceCasePipe } from '@services/ui-services/pipes/sentence-case.pipe';

@Component({
  standalone: true,
  selector: 'app-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss'],
  imports: [CommonModule, CeIconComponent, CounterComponent, SentenceCasePipe],
})
export class BadgesComponent {
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  withIcon = true;
  @Input()
  rightIcon = false;
  @Input()
  clickable = false;
  click() {
    this.onClick.emit();
  }

  @Input()
  Type!: any;

  @Input()
  count: string = '23';

  @Input() withOutLabel: boolean = false;
  @Input() codeView: boolean = false;

  @Input()
  IconType: any = 'no_icon';

  @Input() counter: boolean = false;
  @Input() lowerCase: boolean = false;
  @Input() uppercase: boolean = false;
  @Input() divideText: string | undefined = '';
  @Input() dividedText: boolean = false;
  @Input() close: boolean = false;
  @Input() onlyIcon: boolean = false;

  // @Input()
  // icon_type: any = 'person'

  @Input()
  label: string | undefined = '';

  @Input()
  ellipsis = true;

  get type() {
    if (this.Type) return this.Type;

    switch (this.label?.toLowerCase()) {
      case 'complete':
      case 'success':
      case 'payment received':
      case 'active':
      case 'delivered':
      case 'verified':
        return 'completed';

      case 'payment failed':
      case 'failed':
      case 'cancelled':
      case 'rejected':
        return 'cancelled';

      case 'shipped':
      case 'awaiting shipment':
      case 'approved':
      case 'packed':
        return 'live';

      case 'partial_payment':
      case 'pending':
        return 'paused';

      case 'created':
        return 'draft';

      default:
        return 'draft';

      //return 'tag';
    }
  }
}
